/**
 * API URL(本番用)
 */

/**
 * 共通
 */
// ログインユーザ情報取得
export const USER_AUTHINFOS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/userauthinfos/';
// ヘッダー項目生成
export const HEADER_LIST =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/headerlist/';
// バリデーションチェック
export const API_URL_VALIDATION_RESULT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/validationresult/';
// バリデーションチェック(複数)
export const API_URL_MULTIVALIDATION_RESULT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/multivalidationresult/';
// 画像登録
export const API_URL_UPLOAD_IMAGE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/uploadimage/';
// ファイル登録
export const API_URL_UPLOAD_CSV =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/uploadcsv/';
// ファイル情報登録
export const API_URL_REGIST_DATA =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/registdata/';
// ブロック実行必要回数の取得
export const API_URL_RUN_COUNT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/runcount/';
// 辞書値取得
export const API_URL_DICVALUES =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/dicvalues/';
// 情報出力
// TODO 現在は注文情報(ORDER)のみ対応
export const API_URL_OUTPUT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/output/';

// ログイン
export const API_LOGIN = 'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/login/';
// パスワード再設定
export const API_FORGOT_PASSWORD = 'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/forgot_password/';
// 再設定パスワード確認
export const API_CONFIRM_FORGOT_PASSWORD = 'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/confirm_forgot_password/';

/**
 * マスタ画面
 */
// お知らせマスタ管理／確認(GET)
export const API_URL_INFORMATIONS2 =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/informations2';
// お知らせマスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_INFORMATION =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/informations/';
// お知らせマスタ管理／検索画面(GET)
export const API_URL_SEARCH_INFORMATION =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchinformations/';
// お知らせマスタ管理／登録画面(GET)
export const API_URL_INPUT_INFORMATION =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputinformations/';

// ユーザマスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_USER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/users/';
// ユーザマスタ管理／検索画面(GET)
export const API_URL_SEARCH_USER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchusers/';
// ユーザマスタ管理／登録画面(GET)
export const API_URL_INPUT_USER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputusers/';

// 営業日マスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_BIZDAY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/bizdays/';
// 営業日マスタ管理／検索画面(GET)
export const API_URL_SEARCH_BIZDAY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchbizdays/';
// 営業日マスタ管理／登録画面(GET)
export const API_URL_INPUT_BIZDAY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputbizdays/';

// 組織マスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_DEPARTMENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/departments/';
// 組織マスタ管理／検索画面(GET)
export const API_URL_SEARCH_DEPARTMENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchdepartments/';
// 組織マスタ管理／登録画面(GET)
export const API_URL_INPUT_DEPARTMENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputdepartments/';

// 在庫調整(POST:入庫登録/PUT:在庫調整)
export const API_URL_STOCK =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/stock/';

// 届先マスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_DELIVERY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/deliveries/';
// 届先マスタ管理／検索画面(GET)
export const API_URL_SEARCH_DELIVERY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchdeliveries/';
// 届先マスタ管理／登録画面(GET)
export const API_URL_INPUT_DELIVERY =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputdeliveries/';

// 販促資材マスタ管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/items/';
// 販促資材マスタ管理／検索画面(GET)
export const API_URL_SEARCH_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchitems/';
// 販促資材マスタ管理／登録画面(GET)
export const API_URL_INPUT_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputitems/';

/**
 * 注文画面
 */
// 注文情報／REST API(GET:一覧/GET:詳細/POST:登録)
export const API_URL_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orders/';
// 注文情報／検索画面(GET)
export const API_URL_SEARCH_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchorders/';
// 注文情報／登録画面(GET)
export const API_URL_INPUT_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputorders/';
// 注文情報／詳細（発注者情報）(GET)
export const API_URL_USER_DEPARTMENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/userdepartments/';

// 発注管理／REST API(GET:詳細/POST:登録/DELETE:削除)
export const API_URL_WORK_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/workorders/';
// 発注管理／更新(PUT)
export const API_URL_ORDER_STATUS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orders/{0}/status';
// 発注管理／更新(PUT)
export const API_URL_ORDER_CANCEL =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orders/{0}/cancel/';
// 発注管理／登録画面(GET)
export const API_URL_INPUT_WORK_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputworkorders/';
// 発注管理／登録画面(GET)
export const API_URL_INPUT_ORDER_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputorderitems/';

// 発注管理_届先／REST API(GET:一覧/GET:詳細)
export const API_URL_ORDER_DELIVERIE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orderdeliveries/';
// 発注管理_届先／検索画面(GET)
export const API_URL_SEARCH_ORDER_DELIVERIE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchorderdeliveries/';
// 発注管理_届先／REST API(GET:一覧/POST:登録/DELETE:削除)
export const API_URL_WORK_ORDER_DELIVERIE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/workorderdeliveries/';

// 発注管理_販促資材／REST API(GET:一覧)
export const API_URL_WORK_ORDER_ITEM_STOCK_INFO =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/workitemstockinfo/';
// 発注管理_販促資材／REST API(GET:一覧/GET:詳細)
export const API_URL_ORDER_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orderitems/';
// 発注管理_販促資材／検索画面(GET)
export const API_URL_SEARCH_ORDER_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchorderitems/';
// 発注管理_販促資材／REST API(POST:登録/DELETE:削除)
export const API_URL_WORK_ORDER_ITEM =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/workorderitems/';
// 発注管理／注文関連WORK削除(DELETE)
export const API_URL_SUB_WORK_ORDERS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/subworkorders/';

// 注文情報/一括承認(PUT)
export const API_URL_APPROVAL_ORDER =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/orders/bulk/approval/';

/**
 * 在庫メンテナンス画面
 */
// 在庫メンテナンス管理／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_STOCK_MAINTENANCE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/stockmaintenances/';
// 在庫メンテナンス管理／検索画面(GET)
export const API_URL_SEARCH_STOCK_MAINTENANCE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searcstockmaintenances/';
// 在庫メンテナンス管理／登録画面(GET)
export const API_URL_INPUT_STOCK_MAINTENANCE =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputstockmaintenances/';
// 在庫メンテナンス管理／更新(PUT)
export const API_URL_STOCK_MAINTENANCES_CANCEL =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/stockmaintenances/{0}/cancel/';

// 製作指示／REST API(GET:一覧/GET:詳細)
export const API_URL_STOCK_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/stockplans/';
// 製作指示／検索画面(GET)
export const API_URL_SEARCH_STOCK_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchstockplans/';
// 製作指示／登録画面(GET)
export const API_URL_INPUT_STOCK_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputstockplans/';
// 製作指示／製作指示登録(入庫予定登録)
export const API_URL_STOCK_PLAN =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/stockplan/';

/**
 * 計画情報画面 利用しない
 */
// 計画情報一覧／REST API(GET:一覧/GET:詳細/POST:登録/PUT:更新/DELETE:削除)
export const API_URL_EVENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/events/';
// 計画情報一覧／検索画面(GET)
export const API_URL_SEARCH_EVENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchevents/';
// 計画情報一覧／登録画面(GET)
export const API_URL_INPUT_EVENT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputevents/';
// 計画情報／更新(PUT)
export const API_URL_EVENTPLANINFODELIVERYGROUPS_STATUS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/eventplaninfodeliverygroups/{0}/status';

// 計画数入力・確認／イベント名プルダウン(GET)
export const API_URL_QUANTITY_PLAN_EVENTS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputquantityplanevents/';

// 計画数入力／REST API(GET:一覧/GET:詳細/POST:登録)
export const API_URL_QUANTITY_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/quantityplans/';
// 計画数入力／検索画面(GET)
export const API_URL_SEARCH_QUANTITY_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchquantityplans/';
// 計画数入力／登録画面(GET)
export const API_URL_INPUT_QUANTITY_PLANS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inputquantityplans/';

// 計画数確認／REST API(GET:一覧/GET:詳細)
export const API_URL_EVENT_PLAN_INFO_DELIVERY_GROUPS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/eventplaninfodeliverygroups/';
// 計画数確認／検索画面(GET)
export const API_URL_SEARCH_EVENT_PLAN_INFO_DELIVERY_GROUPS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searcheventplaninfodeliverygroups/';

/**
 * 帳票画面 利用しない
 */
// 棚卸帳票／検索画面(GET)
export const API_URL_SEARCH_INVENTORY_SUMMARYS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchinventorysummarys/';
// 棚卸帳票／IMD棚卸集計表作成・ダウンロード(GET)
export const API_URL_INVENTORY_SUMMARYS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/inventorysummarys/';
// IMD費用明細帳票／検索画面(GET)
export const API_URL_SEARCH_COST_SUMMARYS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/searchcostsummarys/';
// IMD費用明細帳票／IMD費用明細作成・ダウンロード(GET)
export const API_URL_COST_SUMMARYS =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/costsummarys/';

/**
 * 業務バリデーションチェック
 */
// 販促資材マスタ／編集時業務チェック(POST)　利用しない
export const API_URL_CHECK_EDIT_ITEM_RESULT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/checkedititemresult/';
// 注文情報履歴／編集時業務チェック(POST)
export const API_URL_CHECK_EDIT_ORDER_RESULT =
  'https://xxxxx.execute-api.ap-northeast-1.amazonaws.com/prod/checkeditorderresult/';
